import { InboxOutlined, SearchOffRounded } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

import { useTranslation } from "@/context/I18nProvider";

export const GridNoRowsOverlay = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ height: "100%", p: 2 }}>
      <InboxOutlined sx={{ fontSize: 40, color: "text.disabled" }} />
      <Typography variant="body2" color="text.secondary" align="center">
        {t("grid.noRows")}
      </Typography>
    </Stack>
  );
};

export const GridNoResultsOverlay = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ height: "100%", p: 2 }}>
      <SearchOffRounded sx={{ fontSize: 40, color: "text.disabled" }} />
      <Typography variant="body2" color="text.secondary" align="center">
        {t("grid.noResults")}
      </Typography>
    </Stack>
  );
};
